import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import MyRouter from "routers/index";
import { updateUser } from "./redux/reducers/userReducer";
import { setAgency } from "./redux/reducers/agencyReducer";
import { setFormOptions } from "./redux/reducers/formoptionsReducer";
import { updateLoadingIsStatus } from "./redux/reducers/spinnerReducer";
import { updateFormData } from "./redux/reducers/formReducer";
import api from './api';

const App = ({user, isLoading}) => {
  const dispatch = useDispatch();
  const [isUserLoaded, setUserLoaded] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const token = localStorage.getItem('access_token');

  useEffect(() => {
    if(!token) {
      setInitialLoadComplete(true);
      return;
    }
    
    if(!isUserLoaded) {
      api.getUser((res) => {
        if (res && res.data) {
          setUserLoaded(true);
          const userId = res.data.id;
          api.getUserCompanies({id: userId}, (res2) => {
            const company = res2.data && res2.data.length > 0 ? res2.data[0] : null;
            let resUser = res.data;
            api.getCompanyType(userId, (companyTypeRes) => {
              let companyType = null;
              if (companyTypeRes && companyTypeRes.data) {
                companyType = companyTypeRes.data.company_type;
                localStorage.setItem('company_type', companyType);
                dispatch(updateFormData({ company_type: companyType }));
              }
              dispatch(updateUser({
                ...resUser,
                company: company,
                company_type: company?.type || companyType,
              }));
              api.getFormoptions((resoptions) => {
                if (resoptions && resoptions.data) {
                  dispatch(setFormOptions(resoptions.data));
                }
                setInitialLoadComplete(true);
              });
              
            }, (companyTypeError) => {
              dispatch(updateUser({
                ...resUser,
                company: company,
                company_type: company?.type || null,
              }));
              
              api.getFormoptions((resoptions) => {
                if (resoptions && resoptions.data) {
                  dispatch(setFormOptions(resoptions.data));
                }
                setInitialLoadComplete(true);
              });
            });
          });
        } else {
          localStorage.removeItem('access_token');
          localStorage.removeItem('company_type');
          setUserLoaded(true);
          setInitialLoadComplete(true);
        }
      });
    }
  }, [isUserLoaded, token, dispatch]);

  // loading spinner
  if (!initialLoadComplete) {
    return (
      <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
        <MyRouter initialLoadComplete={initialLoadComplete} />
      </div>
    );
  }

  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
        <MyRouter initialLoadComplete={initialLoadComplete} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  isLoading: state.spinner.isLoading
});

export default connect(mapStateToProps, { updateUser })(
  App
);
